export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31')
];

export const server_loads = [0,2,3];

export const dictionary = {
		"/": [~4],
		"/@[user=user_slug]/collections": [~5,[2]],
		"/account": [7,[3]],
		"/account/my-event-registrations": [~8,[3]],
		"/account/settings": [~9,[3]],
		"/account/team-access": [~10,[3]],
		"/all": [~11],
		"/analyze-font": [12],
		"/assets": [~13],
		"/calendar": [~14],
		"/login": [~15],
		"/login/confirm/[code]": [~16],
		"/logout": [~17],
		"/messages": [~18],
		"/new/media": [~20],
		"/new/[type]": [~19],
		"/playground/buttons": [21],
		"/playground/inputs": [22],
		"/playground/markdown": [23],
		"/playground/popover": [24],
		"/playground/search-select": [25],
		"/playground/toast": [26],
		"/posters": [~27],
		"/settings": [~28],
		"/signature": [~29],
		"/soon": [~30],
		"/users": [~31],
		"/[entry=entry_slug]": [~6]
	};

export const hooks = {
	handleError: (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);